<template>
	<div class="gap" :style="cssVars"></div>
</template>

<script>
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		cssVars() {
			return {
				'--height': this.getSize(this.content.size),
				'--height-resposive': this.getResponsiveSize(this.content.size),
			}
		},
	},
	methods: {
		getSize(size) {
			switch (size) {
				case 'small':
					return '3rem'
				case 'medium':
					return '5rem'
				case 'large':
					return '20rem'
				case 'xl-large':
					return '30rem'
				default:
					return '3rem'
			}
		},
		getResponsiveSize(size) {
			switch (size) {
				case 'small':
					return '1rem'
				case 'medium':
					return '2rem'
				case 'large':
					return '8rem'
				case 'xl-large':
					return '10rem'
				default:
					return '1rem'
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';
.gap {
	height: var(--height);
	@include respond-below('phone') {
		height: var(--height-resposive);
	}
}
</style>
